// extracted by mini-css-extract-plugin
export default {"mainContainer":"TempComponent_mainContainer__c6pHH","imgContainer":"TempComponent_imgContainer__2g7ih","fig":"TempComponent_fig__KwVMr","white":"TempComponent_white__9bf58"};